export function setFavicon(url: string): void {
  let link = document.querySelector<HTMLLinkElement>('link[rel~="icon"]') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = url;
}
